
import * as React from 'react'
import {CSSProperties} from 'react';
import {CampusHeader} from '../Components/CampusHeader';
import * as Tgcc from '../tgccGlobal';
import {CampusFooter} from '../Components/CampusFooter';
import Radium, { StyleRoot } from 'radium';
import * as Request from '../tgccRequest';
import {Message} from '../Components/Message';
import {browserHistory} from 'react-router';



const feedbackDiv: CSSProperties = {
    display:'flex',
    flexDirection:'column',
    margin:'10% auto',    
}

const btn : CSSProperties = {
    border: "1px solid transparent",
    backgroundColor: "rgb(226, 117, 88)",
    height: '40px',
    lineHeight: '40px',
    fontSize: '15px',
    padding: '0px 25px',
    textAlign: 'center',
    textTransform: 'uppercase',
    color: 'white',
    alignSelf: 'center',
    cursor: 'pointer',
    margin: '10px auto',
    width: '142px',
    fontFamily: 'Lulo'
}
const label: CSSProperties = {
    fontFamily:"BarlowMedium",
    color:'rgb(166, 166, 166)'
}
const hdr: CSSProperties = {
    textAlign: 'center',
    fontFamily: 'BarlowLight',
    color: 'rgb(166, 166, 166)',
    fontSize:'20px'
}

const textarea: CSSProperties = {
    height:'150px',
    border:'1px solid rgb(166, 166, 166)',
    fontFamily:"BarlowMedium",
    color: 'rgb(166, 166, 166)',
    fontSize:"16px",
    letterSpacing:'1px'
}
const style: CSSProperties = {
    border:'1px solid rgb(166, 166, 166)',
    fontFamily:"BarlowMedium",
    color: 'rgb(166, 166, 166)'
}
const errStyle: CSSProperties = {
    color:'red',
    textAlign:'center',
    position:"relative",
    top:'145px',
    fontSize:'15px'
}
const formDiv: React.CSSProperties = {
    position:'fixed',
    backgroundColor:'white',
    width:'400px',
    bottom:'61px',
    right:'9px',
    zIndex:2,
    padding:'20px',
    height:'425px'
}
const helpDiv: React.CSSProperties = {
    fontFamily:"BarlowMedium",
    position:'fixed',
    bottom:'0px',
    right:'0px',
    width:'250px',
    height:'60px',
    backgroundColor:'#3a54b4',
    display:'flex',
    alignItems:'center',
    justifyContent:'center',
    color:'white',
    cursor:'pointer',
    zIndex:2,
    textTransform:'uppercase'
}
const btnDiv: React.CSSProperties = {
    display:'flex',
    alignItems:'center'
}
const cancelBtn: React.CSSProperties = {
    width:'200px',
    height:'40px',
    lineHeight:'40px',
    textTransform:'uppercase',
    backgroundColor:"rgb(233, 230, 230)",
    fontFamily:"Lulo",
    fontSize:"15px",
    textAlign:'center',
    color:'grey',
    cursor:'pointer'
}


class _CampusFeedback extends React.Component<Tgcc.BaseProps,any> {
    state = {
        name:null,
        email:null,
        message:null,
        finished:false,
        error:'',
        isWaiting: false,
        help: false
    }
    handleNameChange = (evt: React.FormEvent<HTMLInputElement>) =>{
        this.setState({name:evt.currentTarget.value});
    }
    handleEmailChange = (evt:React.FormEvent<HTMLInputElement>) => {
        this.setState({email:evt.currentTarget.value});
    }
    handleMessageChange = (evt:React.FormEvent<HTMLTextAreaElement>) => {
        this.setState({message:evt.currentTarget.value});
    }
    sendMessage = () => {       
        if(!this.state.name){
            this.setState({error:"Please provide your name."})
        } else if(!this.state.email){
            this.setState({error:"Please provide your email address."})
        } else if(!this.state.message){
            this.setState({error:"Please provide a message."})
        }else {
            this.setState({isWaiting:true});
            var feedback = new Tgcc.Feedback;
            feedback.name = this.state.name;
            feedback.email = this.state.email;
            feedback.message = this.state.message;
            feedback.timestamp = new Date().toLocaleString();
            Request.sendFeedback(feedback,this.finished)
        }
    }
    finished = () => {
        this.setState({finished:true});
    }
    whenFinished = () => {
        browserHistory.push(Tgcc.Routes.Campus);
    }
    getThankYou = () => {
        return <Message 
            Title="We will be in touch!"         
            UseTitleScript={true}
            Message1="Thanks for reaching out!"
            onContinue={this.cancel}
        />
    }
    helpMe = () => {
        if(this.state.help){
            this.setState({help:false});
        }else {
            this.setState({help:true});
        }
        
    }
    cancel = () => {
        this.setState({help:false});
        this.setState({finished:false});
        this.setState({isWaiting:false});
    }
    getHelp(){
        var help = this.state.help ? this.needHelp() : null 
        return help  
    }

    needHelp() {
        var thankYou = this.state.finished ? this.getThankYou() : null;
        var waiting = this.state.isWaiting ? Tgcc.workingGif: <div style={btnDiv}><div onClick={this.cancel} style={cancelBtn}>Cancel</div><div style={btn} onClick={this.sendMessage}>Submit</div></div>
        return (
            <div style={formDiv}>
              <div id="feedback"></div> 
                    <div style={hdr}>What can we help you with?</div>
                    <div style={errStyle}>{this.state.error}</div>
                    <div style={feedbackDiv} className='feedbackDiv'>
                        <label htmlFor="Name" style={label}>Name:</label>
                        <input style={style} type="text" name="name" onChange={this.handleNameChange}/>
                        <label htmlFor="email" style={label}>Email:</label>
                        <input style={style} type="text" name="email" onChange={this.handleEmailChange}/>
                        <label htmlFor="message" style={label}>Message:</label>
                        <textarea style={textarea} type="text" name="message" onChange={this.handleMessageChange}/> 
                        {waiting}
                    </div>
                      {thankYou}
            </div>
        )
    }
    render () {
        
        return (
            <div>
                <div style={helpDiv} className='help' onClick={this.helpMe}>
                    <div>Have a Question?</div>
                </div>
                {this.getHelp()}
            </div>
        )
    }
}

export var CampusFeedback = Radium(_CampusFeedback);